import { Tooltip, Box } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";

export default function UploadingIcon({ viewFileStatus }) {
  return (
    <Tooltip title="View Uploading File Status">
      <Box
        sx={{ display: "inline-flex", alignItems: "center", width:"10px", justifyContent: "center", position: "relative", cursor: "pointer" }}
        onClick={viewFileStatus}
      >
        <FileUploadIcon
          fontSize="small"
          color="primary"
          sx={{ position: "absolute", "&:hover": {   animation: "none",    transform: "translateY(0)",    opacity: 1, }, }}
        />
      </Box>
    </Tooltip>
  );
}
